import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';

// props: isAuthenticated:boolean, element:ReactNode
const PrivateRoute = ({ isAuthenticated, element }) => {
  const location = useLocation();
  if (isAuthenticated) return element;
  return <Navigate to="/403" replace state={{ from: location.pathname }} />;
};
export default PrivateRoute;

